import type { NamePath, Rule } from 'antd/es/form'

import { BOOSTER_PROGRAM_MESSAGES } from 'constants/booster-program'

/**
 * Builds a Form.Item name that is either top-level (standalone form) or nested
 * under a Form.List index when `parent` is provided.
 */
export const buildName = (parent: number | undefined, key: string): NamePath =>
  parent === undefined ? key : [parent, key]

export const isFormValidateError = (err: unknown): boolean =>
  typeof err === 'object' && err !== null && 'errorFields' in err

/**
 * Validation rules for a milestone purchase quantity. Enforces strict increase
 * over the previous milestone (E07) when `getPreviousThreshold` is provided,
 * and strict decrease below the next milestone (E08) when `getNextThreshold`
 * is provided.
 */
export const getThresholdRules = (
  index: number,
  getPreviousThreshold?: () => number | undefined,
  getNextThreshold?: () => number | undefined
): Rule[] => {
  const rules: Rule[] = [
    { required: true, message: 'Required' },
    { type: 'number', min: 1, message: BOOSTER_PROGRAM_MESSAGES.E01('Purchase quantity') },
  ]
  if (index > 0 && getPreviousThreshold) {
    rules.push({
      validator: (_, value) => {
        if (value == null) return Promise.resolve()
        const prev = getPreviousThreshold()
        if (prev == null || value > prev) return Promise.resolve()
        return Promise.reject(new Error(BOOSTER_PROGRAM_MESSAGES.E07))
      },
    })
  }
  if (getNextThreshold) {
    rules.push({
      validator: (_, value) => {
        if (value == null) return Promise.resolve()
        const next = getNextThreshold()
        if (next == null || value < next) return Promise.resolve()
        return Promise.reject(new Error(BOOSTER_PROGRAM_MESSAGES.E08))
      },
    })
  }
  return rules
}
